import theme from "/home/semaphore/rbma-daily-archive/src/styles/theme";
export default theme;
